import { useEffect, useState } from 'react';
import { ProcessEnrollmentResponse } from 'shared/types/product';
import { sdk } from 'sdk';
import { getAccountId, getIsAuthenticated, useAppSelector } from 'store';
import { makeSDKCallWithRetries } from 'utils';
import { withCookieValidation } from 'utils/edx-auth';

export const useEnrollments = () => {
  const customerId = useAppSelector(getAccountId);
  const isAuthenticated = useAppSelector(getIsAuthenticated);

  const [enrollments, setEnrollments] = useState([] as string[]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getEnrollmentsOnLoad = async () => {
      const response = await withCookieValidation(() =>
        makeSDKCallWithRetries('enrollment/getEnrollments', customerId, () =>
          sdk.callAction<ProcessEnrollmentResponse>({
            actionName: 'enrollment/getEnrollments',
          }),
        ),
      );

      const responseData = (!response.isError &&
        response.data) as ProcessEnrollmentResponse;

      const error = response.isError
        ? response.error
        : responseData?.isError
          ? responseData.error
          : null;

      if (error) {
        setIsLoading(false);

        const errorCode = (error.code as string) ?? '';
        const errorMessage =
          error?.message ?? (error ? JSON.stringify(error) : 'unknown');

        console.error(
          `Error in useEnrollments extension for customer: ${customerId} ` +
            `with error code: ${errorCode} and error message: ${errorMessage}`,
        );
      }

      if (!responseData.isError && responseData.success) {
        setIsLoading(false);
        setEnrollments(responseData.enrollments);
      }
    };

    if (isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getEnrollmentsOnLoad();
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { enrollments, isLoading };
};
